import * as React from 'react';
import { useState } from 'react';
import Nav from './Global/Nav/Nav';
import { useStaticQuery } from 'gatsby';
import { graphql } from 'gatsby';
import SearchEngine from './Global/Search/SearchEngine';
import TopMessage from './Global/TopMessage/TopMessage';

const Header = ({ homepage = false, hideLinks = false }) => {
  const [searchEngineVisible, setSearchEngineVisible] = useState(false);

  const query = useStaticQuery(graphql`
    query {
      mainMenu: allDatoCmsMenu(filter: { root: { eq: true } }, sort: { position: ASC }) {
        nodes {
          ...MainNavigation
        }
      }
      topMessage: datoCmsTopMessage {
        message
        statusTopMessage
        link {
          ... on DatoCmsGlobalLink {
            id
            label
            url
            content {
              __typename
              ... on DatoCmsPage {
                ...PageLink
              }
              ... on DatoCmsCongress {
                slug
                model {
                  apiKey
                }
              }
            }
          }
        }
        icon {
          gatsbyImageData
          url
          alt
        }
      }
    }
  `);

  React.useEffect(() => {
    if (searchEngineVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'scroll';
    }
  }, [searchEngineVisible]);

  return (
    <>
      {query.topMessage.statusTopMessage && <TopMessage data={query.topMessage} />}
      <header data-datocms-noindex>
        {searchEngineVisible && (
          <SearchEngine searchEngineVisible={searchEngineVisible} setSearchEngineVisible={setSearchEngineVisible} />
        )}

        <Nav
          homepage={homepage}
          navData={query}
          setSearchEngineVisible={setSearchEngineVisible}
          hideLinks={hideLinks}
        />
      </header>
    </>
  );
};

export default Header;
